<template>
  <v-flex>
    <v-dialog
      v-if="this.modelCliente"
      v-model="dialogFormularioCliente"
      :max-width="900"
      persistent
    >
      <cliente-formulario
        @cerrarFormularioCliente="dialogFormularioCliente = false"
        :modelCliente="this.modelCliente"
        :accion="this.accion"
      />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon
            size="30"
            :color="'white'"
            @click="showConfirmacionEliminacion = false"
            >mdi-close-circle</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar el cliente?
            </v-label>
          </v-row>
           <v-row class="mt-4 mb-4" justify="center">
            <v-label v-if="clienteSelec && clienteSelec.reservas.length > 0" :dark="dark"
              >
              Este cliente tiene {{ clienteSelec.reservas.length }}  reservas que serán también eliminadas. 
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip class="mr-4" label color="blue-grey darken-3" @click="_eliminarCliente()">
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip
              label
              class="ml-4"
              color="blue-grey darken-3"
              @click="showConfirmacionEliminacion = false"
            >
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">CLIENTES</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
       <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        <v-chip class="mr-1" link :color="colorEBikeAccent1" @click="_crearCliente" >
          <v-avatar left>
            <v-icon size="20" color="white">mdi-account-plus</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">
            NUEVO CLIENTE
          </h5>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field
              class="mx-4"
              :dark="dark"
              clearable
              outlined
              v-model="busquedaNombre"
              autocomplete="off"
              label="Búsqueda por nombre"
              placeholder="Especifique parte del nombre o los apellidos"
              @keyup.enter="_getClientes(true)"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field
              class="mx-4"
              :dark="dark"
              clearable
              outlined
              v-model="busquedaTelefono"
              autocomplete="off"
              label="Busqueda por teléfono"
              placeholder="Teléfono del cliente"
              @keyup.enter="_getClientes(true)"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field
              class="mx-4"
              :dark="dark"
              clearable
              outlined
              v-model="busquedaEmail"
              autocomplete="off"
              label="Busqueda por email"
              placeholder="Email del cliente"
              @keyup.enter="_getClientes(true)"
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear
            class="mt-12 mb-12"
            :color="colorEBikeAccent1"
            indeterminate
            width="200px"
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="clientes" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table
              locale="es"
              v-if="clientes"
              dense
              light
              :headers="headersLargo"
              :items="clientes"
              :items-per-page="clientes.length"
              hide-default-footer
              class="elevation-1"
            >
            <template v-slot:[`item.agencia`]="{ item }">
              <v-icon color="green" v-if="(item.agencia == 1)">mdi-checkbox-marked-circle</v-icon>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-chip
                  class="mr-1"
                  label
                  small
                  :color="colorAccent2"
                  text-color="white"
                  link
                  @click="_editar(item)"
                >
                  Editar
                </v-chip>

                <v-chip
                  label
                  small
                  color="red lighten-2"
                  text-color="white"
                  link
                  @click="_delete(item)"
                >
                  Eliminar
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ClienteFormulario from "../components/formularios/ClienteFormulario";

export default {
  components: {
    ClienteFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    busquedaNombre: "",
    busquedaTelefono: "",
    busquedaEmail: "",
    accion: "",

    dialogFormularioCliente: false,
    modelCliente: null,
    showConfirmacionEliminacion: false,
   

    headersLargo: [
     // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      {
        text: "NOMBRE",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      { text: "TELÉFONO", align: "left", sortable: false, value: "telefono" },
      {
        text: "EMAIL",
        align: "left",
        sortable: false,
        value: "email",
      },
      {
        text: "AGENCIA",
        align: "center",
        sortable: false,
        width: 100,
        value: "agencia",
      },
      {
        text: "DNI",
        align: "left",
        sortable: false,
        value: "dni",
      },
       {
        text: "DOMICILIO",
        align: "left",
        sortable: false,
        value: "domicilio",
      },
      {
        text: "OBSERVACIONES",
        align: "left",
        sortable: false,
        value: "observaciones",
      },
      { text: "ACCIONES", width: "170px", value: "action", sortable: false, align: "center" },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeAccent1",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("clientes", ["clientes", "clienteSelec"]),
  },

  watch: {},

  mounted() {
    this._getClientes(true);
   
  },

  methods: {
    ...mapActions("clientes", ["getClientes", "eliminarCliente", "updateCliente"]),
    ...mapMutations("clientes", ["setClienteSelec"]),
    
    _inicializarModelCliente() {
      this.modelCliente = {
        id: null,
        nombre: null,
        telefono: null,
        email: null,
        dni: null,
        domicilio: null,
        agencia: 0,
        observaciones: null,
      };
    },

    _imprimir() {},

    async _getClientes(showload) {
      const params = {};
      if (this.busquedaNombre != null && this.busquedaNombre != "") {
        params.nombre = this.busquedaNombre;
      }
      if (this.busquedaTelefono != null && this.busquedaTelefono != "") {
        params.telefono = this.busquedaTelefono;
      }
      if (this.busquedaEmail != null && this.busquedaEmail != "") {
        params.email = this.busquedaEmail;
      }
      await this.getClientes([this.access_token, params, true]);
    },

    _delete(item) {
      this.setClienteSelec(item);
      this.showConfirmacionEliminacion = true;
    },
   
    _crearCliente() {
      this._inicializarModelCliente();
      this.accion = 'crear';
      this.dialogFormularioCliente = true;
    },

    _editar(item) {
      this.setClienteSelec(item);
      let temp = JSON.parse(JSON.stringify(this.clienteSelec));
      this.modelCliente = temp;
      this.accion = 'editar';
      this.dialogFormularioCliente = true;
    },

    async _eliminarCliente() {
      this.showConfirmacionEliminacion = false;
      if (this.clienteSelec != null) {
        await this.eliminarCliente([this.access_token, this.clienteSelec.id]);
      }
    },
  },
};
</script>

